import IconButton from '@/components/ui/custom/buttons/IconButton';
import TextWithCopy from '@/components/ui/custom/dataDisplay/TextWithCopy';
import { useCopy } from '@/hooks/shared/useCopy';
import TextAreaInput from '@/components/ui/custom/dataInput/TextAreaInput';
import Popup from '@/components/ui/custom/Popup';
import {
  CheckIcon,
  DocumentDuplicateIcon,
  PencilSquareIcon,
} from '@heroicons/react/24/outline';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react/jsx-runtime';
import { twJoin, twMerge } from 'tailwind-merge';
type CopyMessageActionProps = {
  message: string;
  isLoading: boolean;
};

export default function CopyMessageAction({
  message,
  isLoading,
}: CopyMessageActionProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'alerts.buttons',
  });
  const [messageToCopy, setMessageToCopy] = useState(message);
  const { handleCopy, isCopied } = useCopy();

  const CopyIcon = isCopied ? CheckIcon : DocumentDuplicateIcon;

  return (
    <Fragment>
      <TextWithCopy
        label={t('copyMessage')}
        target={message}
        clickText
        className={{
          base: twMerge(
            'rounded-full bg-primary-content border-[1px] border-primary px-2 py-1 gap-1.5 cursor-pointer flex-row-reverse',
            isLoading ? 'disabled' : '',
          ),
          text: 'text-primary text-14',
        }}
      />
      <Popup
        reference={
          <IconButton
            className="rounded-full bg-primary p-1"
            icon={<PencilSquareIcon className="w-4 h-4 text-base-100" />}
          />
        }
        placement="bottom-end"
        offset={[0, 10]}
      >
        <div className="w-80 min-h-24 h-fit relative">
          <TextAreaInput
            value={messageToCopy}
            onChange={e => setMessageToCopy(e.target.value)}
            className={{ input: 'min-h-24 font-normal' }}
          />
          <IconButton
            className={twJoin(
              'rounded-lg p-1 absolute bottom-2 right-4',
              isCopied ? 'bg-success' : 'bg-primary',
            )}
            icon={<CopyIcon className="w-4 h-4 text-base-100" />}
            onClick={() => handleCopy(messageToCopy)}
          />
        </div>
      </Popup>
    </Fragment>
  );
}
